import { PeppolItemStatusConfig } from '../interfaces/peppol-item.interface';

export const PEPPOL_DOCUMENT_CONFIG: Record<
  'connected' | 'unconnected',
  PeppolItemStatusConfig
> = {
  connected: {
    icon: 'file_check_03',
    colorClass: 'info',
    label: 'PEPPOL.DOCUMENT.Connected',
  },
  unconnected: {
    icon: 'file_minus_03',
    colorClass: 'error',
    label: 'PEPPOL.DOCUMENT.NotConnected',
  },
};
